import React, { useEffect } from "react";
import { Provider } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import ScrollToTop from "common/ScrollToTop";
import store from "state/store";
import { BreakpointProvider } from "components/common/wrappers/withBreakpoint";
import KosmofiLanding from "pages/Kosmofi/Landing";

const AppKosmofi = () => {
  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = '/kosmo_favicon.png';
  }, []);

  return (
    <Router>
      <Provider store={store}>
        <BreakpointProvider>
          <Helmet />
          <ScrollToTop />
          <Switch>
            <Route
              sensitive
              path="/:anything*([A-Z]):anything*/"
              render={(props) => (
                <Redirect to={`${props.location.pathname.toLowerCase()}`} />
              )}
            />
            <Route exact path="/" component={KosmofiLanding} />
          </Switch>
        </BreakpointProvider>
      </Provider>
    </Router>
  );
};

export default AppKosmofi;
